__turbopack_context__.v({
  "className": "a7m_0q_className",
  "variable": "a7m_0q_variable",
});
